import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { applyLocale } from "../i18n";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const BrandContext = createContext({ name: "PRIME", tagline: "Sécurité privée", logo_file_id: null, refresh: () => {} });

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState({ name: "PRIME", tagline: "Sécurité privée", logo_file_id: null, primary_color: "#0284c7" });

  const refresh = useCallback(async () => {
    try {
      const slug = window.location.pathname.match(/^\/e\/([a-z0-9-]+)/)?.[1];
      const plink = window.location.pathname.match(/^\/(?:postuler|demande-devis)\/([A-Za-z0-9-]+)/)?.[1];
      const r = await axios.get(`${BACKEND}/api/brand`, { withCredentials: true, headers: slug ? { "X-Company": slug } : plink ? { "x-public-link": plink } : {} });
      setBrand({
        name: r.data?.name || "PRIME",
        tagline: r.data?.tagline ?? "",
        logo_file_id: r.data?.logo_file_id || null,
        primary_color: r.data?.primary_color || "#0284c7",
      });
      applyLocale(r.data);
    } catch {
      // endpoint public — pas de redirection en cas d'erreur
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Injecte la couleur principale comme variable CSS au niveau de la racine
  useEffect(() => {
    const hex = brand.primary_color || "#0284c7";
    document.documentElement.style.setProperty("--brand-primary", hex);
    document.documentElement.style.setProperty("--brand-primary-hover", shade(hex, -10));
  }, [brand.primary_color]);

  return <BrandContext.Provider value={{ ...brand, refresh }}>{children}</BrandContext.Provider>;
}

// Décale la luminosité d'une couleur hex de `pct` % (négatif = plus sombre).
function shade(hex, pct) {
  try {
    const m = hex.replace("#", "").match(/.{2}/g);
    if (!m || m.length < 3) return hex;
    const adj = (v) => Math.max(0, Math.min(255, Math.round(parseInt(v, 16) * (100 + pct) / 100)));
    return "#" + m.map(adj).map((v) => v.toString(16).padStart(2, "0")).join("");
  } catch {
    return hex;
  }
}

export function useBrand() { return useContext(BrandContext); }
